<template>
	<div style="margin-top:20px;" class="cart-wrap">
		<b-row class="cart-address" v-show="allFlag">
			<b-col class="adrees-content">
				<div><label style="width:150px;text-align: right;font-weight: bold;">收货人：</label>{{addressInfo.memberDeliveryAddressContacts}}</div>
				<div><label style="width:150px;text-align: right;font-weight: bold;">联系方式：</label>{{addressInfo.memberDeliveryAddressPhone}}</div>
				<!-- <div><label style="width:150px;text-align: right;font-weight: bold;">收货地址：</label>{{addressInfo.memberDeliveryAddressFull}}</div> -->

				<div class="address" v-if="addressInfo.memberDeliveryAddressType == '收货'"><label style="width:150px;text-align: right;font-weight: bold;">默认收货地址：
				</label>{{ addressInfo.province + '' + addressInfo.city + '' + addressInfo.dist + '' + addressInfo.memberDeliveryAddressFull }}</div>
				<div class="address" v-else><label style="width:150px;text-align: right;font-weight: bold;">默认收货地址：
				</label>{{ addressInfo.distributionStationName }}</div>
			</b-col>
			<b-col class="address-btn">
				<b-button size="sm" class="changeAdress" @click="showAddressModal('')">更换地址</b-button>
			</b-col>
			<b-modal v-model="showAddressList" title="更换地址" hide-footer no-close-on-backdrop @close="onClose" size="lg">
				<div>
					<b-table id="address-table" :fields="addressFields" :items="addressItems" small bordered hover
						show-empty empty-text="没有找到匹配的记录" caption-top>
						<template v-slot:cell(addressAction)="row">
							<div>
								<a href="#" v-on:click="confirmAddress(row.item)">选择</a>
							</div>
						</template>
					</b-table>
				</div>
			</b-modal>
		</b-row>
        <Loading :isLoading="saveLoading" />
		<div class="span" style="width: 100%;text-align: center;padding-top: 100px;" v-show="emptyFlag">当前空空如也，请去选购产品</div>
		<div class="cart-info" v-show="titleFlag">
			<span class="span">购物车明细</span>
			<div class="cart-info-wrap" v-for="(preSaleOrderMainVO, index) in preSaleOrderMainVOList" :key="index">
				<b-row class="order-info">
					<b-col style="display:flex;justify-content: flex-start;font-weight: bold;">
						<b-checkbox-group v-if="compareTimeResult(preSaleOrderMainVO.orderItmeList[0].sendProductDate)" @change="changeItem(preSaleOrderMainVO)">
							<b-checkbox class="box" :checked="preSaleOrderMainVO.checked"></b-checkbox>
						</b-checkbox-group>
						交货日期：{{preSaleOrderMainVO.sendProductDate}}({{preSaleOrderMainVO.weekSeq}}周)
						<span v-if="!compareTimeResult(preSaleOrderMainVO.orderItmeList[0].sendProductDate)" style="color: red;">已过期</span>
						</b-col>
					<b-col style="display:flex;justify-content: flex-end;font-weight: bold;">收货地址：{{preSaleOrderMainVO.receiptFullAddress}} <a href="javascript:void(0)" @click="showAddressModal(index)" style="margin-left: 10px;">更换地址</a></b-col>
				</b-row>
				<b-table id="sales-cart-table" :fields="salesCart.fields" :items="preSaleOrderMainVO.orderItmeList" small bordered hover
					show-empty empty-text="没有找到匹配的记录" :busy="salesCart.isTableBusy" caption-top>
					<template v-slot:cell(index)="row">
					        {{ row.index + 1 }}
					</template>
					
					<template v-slot:cell(salesCartAction)="row">
						<div>
							<a href="#" v-on:click="cancelSelectFn(row.item)">取消</a>
						</div>
					</template>
					<!-- 订购数量 -->
					<!-- <template v-slot:cell(orderQuantity)="row" >
						<div>
							<input size="sm" type="number" style="text-align: center;width:100px;"
								:step="row.item.productIncreaseStepAmount"
								:min='row.item.productMinOrderAmount'
								@input="updateOrderAmount($event,row.item)"
								v-model="row.item.orderQuantity">
							</input>
						</div>
					</template> -->
					<template v-slot:cell(orderQuantity)="row" >
						<div>
							<input size="sm" type="text" style="text-align: center;width:100px;"
							@click="showQuantity(row.item)" v-model="row.item.orderQuantity">
							</input>
						</div>
					</template>
				</b-table>
				<!-- 数量弹窗 -->
				<b-modal v-model="changeOrderQuantity.show" size="sm" title="修改订购数量">
					<div>
						数量：
						<input size="sm" type="number" style="text-align: center;width:100px;"
							:step="productIncreaseStepAmount"
							:min='productMinOrderAmount'
							@blur="updateOrderAmount($event)"
							v-model="productPreSaleWarehouseAmount">
						</input>
					</div>
					<template slot="modal-footer">
						<div class="secondaryWrap">
							<b-button variant="secondary" @click="hideOrderQuantity">取消</b-button>
							<b-button variant="success" @click="confirmOrderQuantity">确定</b-button>
						</div>
					</template>
				</b-modal>
				
				<b-form class="order-pro-list">
					<b-form-text class="bf-text">小计: &nbsp;&nbsp; 数量:<span
							class="red-color">{{preSaleOrderMainVO.mainOrderQuantity}}</span>
						&nbsp;&nbsp;金额:<span class="red-color">{{preSaleOrderMainVO.mainTotalMoney}}</span>
					</b-form-text>
				</b-form>
			</div>

			<div v-show="allFlag">
				<b-row class="bottom-card">
					<b-col style="display:flex;justify-content: flex-start;" cols="6">
						<b-form class="order-pro-list">
							<b-checkbox-group class="all-select" @change="selectAll">
								<b-checkbox :checked="allChecked">全选</b-checkbox>
							</b-checkbox-group>
							<b-form-text class="bf-text">
								合计:数量:<span
									class="red-color">{{totalMainCount}}</span>
								金额:<span
									class="red-color">{{totalMainMoney.toFixed(2)}}元</span>
							</b-form-text>
						</b-form>
					</b-col>
					<b-col cols="6">
						<b-row>
							<b-col cols="7">
					 <div style="color: #FF9900;">非自动审核的苗场的产品提交后生成意向单,意向单后台审核后才生成待支付定金单</div>
					</b-col>
					<b-col style="display:flex;justify-content: flex-end;"  cols="5">
						<div class="btns">
							<b-button size="sm" variant="info" v-on:click="onCancelCart()">
								<b-spinner small v-if="salesCart.orderForm.showSubmitSpin"></b-spinner>删除
							</b-button>
							<b-button size="sm" variant="warning" v-on:click="onSubmitShopping()">
								<b-spinner small v-if="salesCart.orderForm.showSubmitSpin"></b-spinner>继续选购
							</b-button>
							<b-button size="sm" variant="danger" v-on:click="submitSalesOrder()">
								<b-spinner small v-if="salesCart.orderForm.showSubmitSpin"></b-spinner>提交
							</b-button>
						</div>
					</b-col>
						</b-row>
					</b-col>
				
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
import Loading from '@/components/loading/Loading.vue'
	import api from "@/api/api";
	import search from '@/libs/search';
	import HttpRequest from '@/libs/axios';
	import {
		formatDateTimeString,
		numberToFixed,
		getTodayDateString
	} from "@/libs/utils";
	export default {
		name: "Cart",
		components: {
		Loading
	},
		data() {
			return {
				detailUuid:'',
				productMinOrderAmount:0,
				productIncreaseStepAmount:0,
				productPreSaleWarehouseAmount:0,
				orderQuantityOld:0,
				sendProductDateArray:[],
				preSaleOrderDetailUuidArray:[],
				sendInformations:[],
				totalMainCount:0,
				totalMainMoney:0,
				allChecked: false,
				// allcheck: false,
				indeterminate: false,
				emptyFlag: false,
				titleFlag: true,
				allFlag: true,
				showAddressList: false,
				addressInfo: {},
				preSaleOrderMainVOList: {},
				changeOrderQuantity:{
					show:false,
					title: '',
					content: '',
				},
				salesCart: {
					items: [],
					isTableBusy: false,
					fields: [
						{
							key: "index",
							label: "序号"
						},
						{
							key: "productCode",
							label: "品种编码"
						},
						{
							key: "productName",
							label: "品种名称"
						},
						{
							key: "orderQuantity",
							label: "数量",
							class: 'table-cloumn-max-width'
							
						},
						{
							key: "unitName",
							label: "单位"
						},
						{
							key: "preSalePlanPrice",
							label: "单价"
						},
						{
							key: "mainTotalMoney",
							label: "金额"
						},
						{
							key: "salesCartAction",
							label: "操作"
						},
					],
					orderForm: {
						itemFee: 0,
						showSubmitSpin: false,
					},

					cartSearch: search.getSearchParams(),
				},
				addressFields: [
					{
						key: 'memberDeliveryAddressContacts',
						label: '联系人'
					},
					// { key: 'memberDeliveryAddressContactNumber', label: '电话' },
					{
						key: 'memberDeliveryAddressPhone',
						label: '手机'
					},
					{
						key: 'memberDeliveryAddressType',
						label: '配送类型'
					},
					// { key: 'memberDeliveryAddressZipCode', label: '邮编' },
					{
						key: 'province',
						label: '省'
					},
					{
						key: 'city',
						label: '市'
					},
					{
						key: 'dist',
						label: '区'
					},
					{
						key: 'memberDeliveryAddressFull',
						label: '详细地址'
					},
					{
						key: 'distributionStationName',
						label: '转运站'
					},
					{
						key: "addressAction",
						label: "操作"
					}
					// { key: 'memberDeliveryAddressDefault', label: '是否默认' }

				],
				addressItems: [],
				timmer:null,
				saveLoading:false,
				isSumbit:false,
				unitList:[],
				selectIndex:''
			}
		},
		mounted() {
			if (!this.checkMemberLogin()) {
				this.$router.push({
					name: "MemberLogin"
				});
				return;
			};
			this.getUserAddressInfo();
			this.getAppPreSaleOrderList();
			this.getMemberAddressList();
			this.getUnitList();
		},
		methods: {
			compareTimeResult(targetDateTime){
				let tdateTime=new Date(targetDateTime);		
				let year = '' + tdateTime.getFullYear();
				let month = '' + (tdateTime.getMonth() + 1);
				let day = '' + tdateTime.getDate();
				if (month.length < 2) month = '0' + month;
				if (day.length < 2) day = '0' + day;
				let dateStr= [year, month, day].join('/');
				let curDateStr=getTodayDateString().replace(/\-/g,'/');
				let curDate=Date.parse(curDateStr);
				let targetDate=Date.parse(dateStr);
				if(curDate>targetDate){
					return false;
				}else{
					return true;
				}
			},
			showQuantity(row){
				//点击表格输入框（真实订购数量）,弹窗
				this.productPreSaleWarehouseAmount=row.orderQuantity;
				this.orderQuantityOld=row.orderQuantity;
				this.detailUuid=row.uuid;
				this.productMinOrderAmount=row.productMinOrderAmount;
				this.productIncreaseStepAmount=row.productIncreaseStepAmount;
				this.changeOrderQuantity.show=true;
			},
			updateOrderAmount(event){
			
				let value=Number(event.target.value);
				//改变弹窗输入框的值，并将值同步到表格输入框（真实订购数量）
				this.preSaleOrderMainVOList.forEach(main => {
					main.orderItmeList.forEach(item =>{
						if (item.uuid == this.detailUuid) {
								
							if (!this.getUnitIsRounded(item.unitName)) {
								value = Math.round(value);
							}
							else {
								value = parseFloat(value.toFixed(2));
							}
							this.productPreSaleWarehouseAmount = value;
							item.orderQuantity = value;
						}
					});
				});
			},
			confirmOrderQuantity(){
				if (this.productPreSaleWarehouseAmount== "") {
					this.$bvModal.msgBoxOk("订购数量不能为空！", {
						title: '提示',
						buttonSize: 'sm'
					});
					return;
				} 
				let item=this.preSaleOrderMainVOList.flatMap(x=>x.orderItmeList).find(item=>item.uuid==this.detailUuid); 
				if (!this.getUnitIsRounded(item.unitName)) {
					if (this.productPreSaleWarehouseAmount % this.productIncreaseStepAmount !== 0) {
						this.$bvModal.msgBoxOk("订购数量必须是最小订购单位的整数倍！", {
							title: '提示',
							buttonSize: 'sm'
						});
						return;
					}
					if (this.productPreSaleWarehouseAmount < this.productMinOrderAmount) {
						this.$bvModal.msgBoxOk("非常抱歉，订购数量不能小于最低起订量！", {
							title: '提示',
							buttonSize: 'sm'
						});
						return;
					}
				}
				else{
					if (this.productPreSaleWarehouseAmount <=0) {
						this.$bvModal.msgBoxOk("非常抱歉，订购数量不能小于等于0！", {
							title: '提示',
							buttonSize: 'sm'
						});
						return;
					}
				}
		
				//弹窗确认按扭，调用后端接口，同步订购数量
				this.salesCart.isTableBusy = true;
				api.updatePreSaleOrderByUuid({detailUuid:this.detailUuid,orderQuantity:this.productPreSaleWarehouseAmount}).then(res => {
					this.salesCart.isTableBusy = false;
					this.changeOrderQuantity.show=false;
					if (res.code === 0) {
						this.getAppPreSaleOrderList();
					}
				});
				
			},
			hideOrderQuantity(){
				//弹窗取消按扭，恢复为原来的订购数量
				this.preSaleOrderMainVOList.forEach(main => {
					main.orderItmeList.forEach(item =>{
						if(item.uuid==this.detailUuid){
							item.orderQuantity=this.orderQuantityOld;
						}
					});
				});
				this.changeOrderQuantity.show=false;
			},
			confirmAddress(address){
				//将用户外键表的关联收货地址改为当前选中的
				if(this.preSaleOrderMainVOList.length==0){
					return;
				}
				let arrayUuid=[];
				if(this.selectIndex!==''){
					arrayUuid.push(this.preSaleOrderMainVOList[this.selectIndex].preSaleOrderRecordUuid);
				}else{
					//this.addressInfo = address;
					this.preSaleOrderMainVOList.forEach((item) => {
						arrayUuid.push(item.preSaleOrderRecordUuid);
					});
				}
				api.getUserAddressInfo({addressId:address.memberDeliveryAddressUuid,preSaleOrderRecordUuidArray:arrayUuid}).then(res => {
					if (res.code === 0) {
						if(this.selectIndex!==''){
							this.preSaleOrderMainVOList[this.selectIndex].receiptFullAddress = res.data.receiptFullAddress;
						}else{
							this.preSaleOrderMainVOList.map(preSaleOrderMainVO => {
								preSaleOrderMainVO.receiptFullAddress = res.data.receiptFullAddress;
							});
							// this.addressInfo.memberDeliveryAddressContacts = address.memberDeliveryAddressContacts;
							// this.addressInfo.memberDeliveryAddressPhone = address.memberDeliveryAddressPhone;
							// this.addressInfo.memberDeliveryAddressFull = address.memberDeliveryAddressFull;
							// if(this.addressInfo.memberDeliveryAddressType == '收货'){
							// 	this.addressInfo.memberDeliveryAddressFull = address.memberDeliveryAddressFull;
							// }
							// if(this.addressInfo.memberDeliveryAddressType == '自提'){
							// 	this.addressInfo.memberDeliveryAddressFull =address.distributionStationName;
							// }
						}
						this.selectIndex='';
						this.showAddressList=false;
					}
				});
			},
			replaceStr(dateStr){
				if(dateStr!=null&&dateStr!=''){
					return dateStr.replace('年','-').replace('月','-').replace('日','');
				}
				return '';
			},
			//单选
			changeItem(preSaleOrderMainVO) {
				preSaleOrderMainVO.checked = !preSaleOrderMainVO.checked;

				let dateStr=this.replaceStr(preSaleOrderMainVO.sendProductDate);

				let predetailUuidArray=preSaleOrderMainVO.orderItmeList.map(x=>x.uuid);							

				if (!preSaleOrderMainVO.checked) {
                    
                    this.preSaleOrderDetailUuidArray=[...new Set(this.preSaleOrderDetailUuidArray.filter(x=>!predetailUuidArray.includes(x)))];

					let sendProductDateArray=this.sendProductDateArray;				
					let dateIndex=sendProductDateArray.indexOf(dateStr);
					// this.sendInformations()
					if(dateIndex>-1){
						sendProductDateArray.splice(dateIndex, 1);
						this.totalMainCount-=preSaleOrderMainVO.mainOrderQuantity;
						this.totalMainMoney-=preSaleOrderMainVO.mainTotalMoney;
					}
					this.sendProductDateArray=sendProductDateArray;

					let informationIndex=this.sendInformations.findIndex(item=>item.sendDate==dateStr);
					if(informationIndex>-1){
						this.sendInformations.splice(informationIndex, 1);
					}
				} else {
				
                    this.preSaleOrderDetailUuidArray.push(...predetailUuidArray);
					this.preSaleOrderDetailUuidArray=[...new Set(this.preSaleOrderDetailUuidArray)];					
					 
					let sendProductDateArray=this.sendProductDateArray;
					let dateIndex=sendProductDateArray.indexOf(dateStr);
					if(dateIndex==-1){
						this.sendProductDateArray.push(dateStr);
						this.totalMainCount+=preSaleOrderMainVO.mainOrderQuantity;
						this.totalMainMoney+=preSaleOrderMainVO.mainTotalMoney;
					}                    
		
				   let informationIndex=this.sendInformations.findIndex(item=>item.sendDate==dateStr);
				   let preSaleOrderRecordUuids=[...new Set(preSaleOrderMainVO.orderItmeList.map(item=>item.preSaleOrderRecordUuid))];	
					if(informationIndex==-1){
						this.sendInformations.push({sendDate:dateStr,preSaleOrderRecordUuids});
					}
					else
					{
						this.sendInformations[informationIndex].preSaleOrderRecordUuids=preSaleOrderRecordUuids;
					}
				}
			},
			//全选，全不选
			selectAll() {
				this.allChecked = !this.allChecked;
				if (this.allChecked) {
					this.sendProductDateArray=[];
					this.sendInformations=[];
					let tCount=0,tMoney=0.0;

					this.preSaleOrderMainVOList.map(preSaleOrderMainVO => {						
						if(this.compareTimeResult(preSaleOrderMainVO.orderItmeList[0].sendProductDate)){
							this.sendProductDateArray.push(this.replaceStr(preSaleOrderMainVO.sendProductDate));
							preSaleOrderMainVO.checked = true;
							tCount+=preSaleOrderMainVO.mainOrderQuantity;
							tMoney+=preSaleOrderMainVO.mainTotalMoney;
						}
						preSaleOrderMainVO.orderItmeList.forEach(e=>this.preSaleOrderDetailUuidArray.push(e.uuid))
						let dateStr=this.replaceStr(preSaleOrderMainVO.sendProductDate);
						let preSaleOrderRecordUuids=[...new Set(preSaleOrderMainVO.orderItmeList.map(item=>item.preSaleOrderRecordUuid))];
						this.sendInformations.push({sendDate:dateStr,preSaleOrderRecordUuids});
					});
					this.totalMainCount=tCount;
					this.totalMainMoney=tMoney;
				} else {
					this.sendProductDateArray=[];
					this.preSaleOrderMainVOList.map(preSaleOrderMainVO => {
						preSaleOrderMainVO.checked = false;
					});
					this.totalMainCount=0;
					this.totalMainMoney=0;
					this.sendInformations=[];
				}
			},
			onClose(e) {
				this.selectIndex='';
			},
			getUserAddressInfo() {
				let address = this.getAddressInfo();
				if(address){
					this.addressInfo = address;
				}
			},
			// 获取购物车列表
			getAppPreSaleOrderList() {
				this.salesCart.isTableBusy = true;
				// api.getAppPreSaleOrderList(this.salesCart.cartSearch).then(res => {
				api.getAppPreSaleOrderNoSumbitIntentioList(this.salesCart.cartSearch).then(res => {
					this.salesCart.isTableBusy = false;
					if (res.code === 0) {
						this.preSaleOrderMainVOList = res.data.preSaleOrderMainVOList;
						
						if (res.data.preSaleOrderMainVOList != null) {
							if (res.data.preSaleOrderMainVOList.length == 0) {
								this.emptyFlag = true;
								this.allFlag = false;
								this.titleFlag = false;
							}
							else{
								this.preSaleOrderMainVOList = res.data.preSaleOrderMainVOList;
							}
							this.totalMainCount=0;
							this.totalMainMoney=0;
						}
						else{
							this.emptyFlag = true;
							this.allFlag = false;
							this.titleFlag = false;
						}
					}
				});
			},
			// 获取地址
			getMemberAddressList() {
				api.webGetMemberDeliveryAddressList().then(res => {
					if (res.code === 0) {
						this.addressItems = res.data.addresses;
					}
                });
			},
            showAlert(msg){
                this.$bvModal.msgBoxOk(msg, {
                	title: '提示',
                	buttonSize: 'sm'
                });
            },
			cancelSelectFn(row) {
				//删除子订单
				if (row.uuid == "") {
					this.$bvModal.msgBoxOk("参数异常，请退出页面重新操作", {
						title: '提示',
						buttonSize: 'sm'
					});
					return;
				}
				this.salesCart.isTableBusy = true;
				api.closePreSaleOrder({
					uuid: row.uuid
				}).then(res => {
					this.salesCart.isTableBusy = false;
					if (res.code === 0) {
                        this.showAlert("取消成功");
					}
					else if(res.code === 11){
						this.showAlert(res.message);
					}
                    this.getAppPreSaleOrderList();
				});
			},
			// 继续选购
			onSubmitShopping() {
				this.$router.push({
					path: "/product/product-list",
					query: {
						tabIndex: 1
					}
				});
			},
			// 提交订单
		async submitSalesOrder() {
				//判断当前小计里是否有0的订单，如果有，则提示要去除
				let zeroSign = false;
				this.preSaleOrderMainVOList.forEach((item) => {
					if (item.mainTotalMoney == 0) {
						zeroSign = true;
						return;
					}
				});
				if (zeroSign) {
					this.$bvModal.msgBoxOk("产品金额不能为0，请取消相应的产品！", {
						title: '提示',
						buttonSize: 'sm'
					});
					return;
				}
				if(this.sendProductDateArray.length==0){
					this.$bvModal.msgBoxOk("请勾选交货日期！", {
						title: '提示',
						buttonSize: 'sm'
					});
					return;
				}
				if(this.isSumbit)
				{
					this.$Message.info('不能连续提交');
					return;
				}
				this.isSumbit=true;
				this.saveLoading=true;
				this.salesCart.isTableBusy = true;
				let preSaleOrderRecordUuids=this.sendInformations.map(x=>x.preSaleOrderRecordUuids).flat(); 
		       let seedfarmResult=await	api.getSeedFarmListByPreSaleOrderUuids({preSaleOrderRecordUuids})
			   if(seedfarmResult.code==0){
				   let seedFarms=seedfarmResult.data;				   
				   let  autoChecks=[...new Set(seedFarms.map(x=>x.autoCheckIntention==1?1:0))];
				   if(autoChecks.length>1){
					this.$bvModal.msgBoxOk("提交的预售单所属的苗场意向单自动审核状态有多个", {
						title: '提示',
						buttonSize: 'sm'
					});
					this.saveLoading = false;
					this.salesCart.isTableBusy = false;
					return;
				   }
				   if (autoChecks[0] == 1) {					   
				      //苗场设置自动审核,还是走之前的流程，不生成意向单
					   api.submitDepositBillRecord({ sendProductDateArray: this.sendProductDateArray, addressId: this.addressInfo.memberDeliveryAddressUuid,isReception:true }).then(async (res) => {
						   this.salesCart.isTableBusy = false;
						   this.saveLoading = false;
						   this.isSumbit = false;
						   let code=await res.code;

						   if (code === 0) {
							   let depositResult=await  api.getDepositBillListByPreSaleUuid({PresaleDetailUuids:this.preSaleOrderDetailUuidArray});
							
							   let deposits=[];
							   if(depositResult.code==0){
								deposits= depositResult.data.depositBillList.filter(x=>x.depositBillRecordPaidStatus=="未支付").map(x=>x.depositBillRecordUuid);
								deposits=[...new Set(deposits)];
							   }
							  							   
							   let sendProductDate = encodeURIComponent(JSON.stringify(this.sendProductDateArray));
							   let depositUuids = encodeURIComponent(JSON.stringify(deposits));
							   this.$Message.info('提交成功');
							   this.$router.push({
								   path: "/member/order-confirm",
								   query: {
									   sendProductDateArray: sendProductDate,
									   depositUuids
								   }
							   });
						   }
					   });
				   }
				   else {
					   //苗场设置不是自动审核，生成意向单
					   api.submitIntentionRecord({ sendInformations: this.sendInformations, addressId: this.addressInfo.memberDeliveryAddressUuid }).then(res => {
						   this.salesCart.isTableBusy = false;
						   this.saveLoading = false;
						   this.isSumbit = false;
						   if (res.code === 0) {
							   this.$Message.info("提交成功，现跳转至意向单。", {
								   title: '提示',
								   buttonSize: 'sm'
							   });
							   setTimeout(() => {
								   this.$router.push({
									   path: "/member/intention-list"
								   });
							   }, 1000);
						   }
					   });
				   }
			   }
			},
			salesCartItemSelectChange() {},
			// 变更地址
			// onClickChangeAddress(){
			// 	this.$router.push({
			// 	    path: "/member/person-info",
			// 	    query: { tabIndex: 2 }
			// 	});
			// }
			//清空购物车
			onCancelCart(){
				if(this.sendProductDateArray.length==0){
					this.$bvModal.msgBoxOk("请勾选交货日期！", {
						title: '提示',
						buttonSize: 'sm'
					});
					return;
				}
				this.salesCart.isTableBusy = true;
				api.closePreSaleOrderListBySendProductDate({sendProductDate:this.sendProductDateArray}).then(res => {
					this.salesCart.isTableBusy = false;
					if (res.code === 0) {
					    this.showAlert("删除成功");
					}
					else if(res.code === 11){
						this.showAlert(res.message);
					}
					this.getAppPreSaleOrderList();
				});
			},
			getUnitList() {
			   api.getUnitList().then(res => {
					if (res.code == 0) {
						this.unitList = res.data.records
					}
				})
			},
			getUnitIsRounded(unitName) {
				let unitPro = this.unitList.find(x => x.unitName == unitName);
				if (!unitPro) {
					return false;
				}
				return unitPro.isRounded == 0 ;
			},
			showAddressModal(index){
				this.showAddressList = true;
				this.selectIndex=index;

			}
	}
}
</script>

<style>
	.cart-address {
		padding: 10px;
		background-color: #f3f3f3;
		font-size: 16px;
		border-radius: 6px;
	}

	.address-btn {
		display: flex;
		justify-content: flex-end;
		height: 38px;
		line-height: 38px;
	}

	.cart-wrap .row {
		margin-right: 0px !important;
		margin-left: 0px !important;
		align-items: center;
	}

	.cartInfo-wrap {
		padding-left: 0px;
		padding-right: 0px;
	}

	.cart-wrap .address-btn .btn-secondary {
		background-color: #00b151 !important;
		border: #00b151 !important;
		font-size: 16px !important;
	}

	.cart-wrap .span {
		font-size: 20px;
		font-weight: bold;
	}
	.cart-wrap .form-text{margin-top:0px !important;}
	.cart-wrap .cart-info{margin-top: 20px;width:100%;}
	.cart-wrap .order-info{display:flex;align-items: center;padding:5px 0px;border:1px solid #dbdbdb;border-bottom: none;}

	.order-pro-list {
		position:relative;
		padding:0px 0px;
		display: flex;
		justify-content: flex-end;
	}
	.all-select{position: absolute;left: 0px;top: 10px;}
	.cart-wrap .order-pro-list .bf-text {
		font-weight: bold;
		font-size: 14px;
		color: #212529;
		opacity: 1;
		border: 0 !important;
		padding-left:70px !important;
	}

	.order-pro-list .red-color {
		font-weight: bold;
		color: #ec4040;
		padding-right: 25px;
		font-size: 25px;
	}

	.cart-wrap .bottom-card{display:flex;align-items: center;padding:0px 0px;background-color: #f3f3f3;margin-top:20px;border-radius: 6px;position:relative;}

	.table.b-table[aria-busy="true"] {
		opacity: 1 !important;
	}
	.cart-info-wrap{padding:0px !important;}

	.addres-card {
		margin-bottom: 20px;
		border: 0 !important;
		border-bottom: 1px solid #ccc !important;
	}
	.cart-wrap .table-bordered td, .cart-wrap .table-bordered th{border:1px solid #DBDBDB;}
	.btns {
		display: flex;
		justify-content: flex-end;
		padding: 20px 0px;
	}

	.btns .btn {
		margin-right: 10px;
	}

	.cart-order-info .row {
		margin-right: 0px;
		margin-left: 0px;
	}


	.custom-control-input:checked~.custom-control-label::before {
		background-color: #00b151 !important;
		border: #00b151 !important;
	}

	.table-bordered thead td,
	.table-bordered thead th {
		text-align: center !important;
	}

	.table-bordered td,
	.table-bordered th {
		text-align: center !important;
	}
	.address{
		 white-space:nowrap;
	}
	/* .cart-wrap .form-control-sm{width:100px;} */
	.cart-wrap .table-cloumn-max-width{max-width:60px;}
	.secondaryWrap .btn-secondary{background-color: #6c757d !important;border-color: #6c757d !important;}
	.btns .btn-info{background-color: #c5c8ce !important;border-color:#c5c8ce !important;}
</style>



// WEBPACK FOOTER //
// src/view/member/cart.vue